<template>
  <card
    title="חשבוניות שלא נשלחו"
    :linkTo="`/invoices?notSentByEmail=true`"
    actionButton="לכל החשבוניות שלא נשלחו"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {},

  methods: {
    format,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            notSentByEmail: true
          };
          return api.get('/invoices', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
